import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ShareMyBetModule } from 'packages/sports/web/app/src/share-my-bet/share-my-bet.module';

import ResultShareMyBetComponent from './components/result-share-my-bet.component';
import BetslipPickOptionsService from './services/betslip-pick-options.service';

@NgModule({
    imports: [CommonModule, ShareMyBetModule],
    providers: [BetslipPickOptionsService],
    declarations: [ResultShareMyBetComponent],
    exports: [ResultShareMyBetComponent],
})
export default class BetslipShareMyBetModule {}
